import './VariableView.scss';

export { default } from './VariableView';
